import { Col, Row } from "antd";
import { isNull } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import SearchSelectEx from "../../../shared/form/SearchSelectEx";
import {
  dateTimeInputStyle,
  mediumInputStyle,
  shortInputStyle,
} from "../../../shared/form/formInputStyles";
import CustomDatePicker from "../../../shared/form/reactHookForm/CustomDatePicker";
import CustomInput from "../../../shared/form/reactHookForm/CustomInput";
import CustomInputCurrency from "../../../shared/form/reactHookForm/CustomInputCurrency";
import CustomInputTextArea from "../../../shared/form/reactHookForm/CustomInputTextArea";
import { dateFormat, dateTimeFormat } from "../../../shared/formatting";
import { ProducerCodeAndName } from "../ProducerCodeAndName";
import dayjs from "dayjs";

const specialLayout = {
  labelCol: { xxl: 12, xl: 12, lg: 8, md: 10, sm: 10, xs: 10 },
  wrapperCol: { xxl: 12, xl: 12, lg: 16, md: 14, sm: 14, xs: 14 },
};

const PolicyDocumentPanel = ({ control, isNew = false }) => {
  const selected = useSelector((state) => state.document.selected);
  const maskSensitiveData =
    useSelector((state) => state.actor?.details?.data?.MaskSensitiveData) &&
    !isNew;
  const transactionTypes = useSelector(
    (state) => state.document.transactionTypes
  );
  const isDownloaded = selected && selected.IsDownloaded;
  const isUserAllowedToSave = !isNull(selected)
    ? selected.IsUserAllowedToSave
    : 1;
  const isUserAllowedToViewCommission =
    selected && selected.IsUserAllowedToViewCommission;
  const isUserAllowedToChangeProducerCodes =
    selected?.IsUserAllowedToChangeProducerCodes;

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={12} xl={8} xxl={8}>
          <ProducerCodeAndName
            layout={{
              labelCol: { xxl: 8, xl: 8, lg: 8, md: 10, sm: 10, xs: 10 },
              wrapperCol: { xxl: 16, xl: 16, lg: 16, md: 14, sm: 14, xs: 14 },
            }}
            control={control}
            disabled={!isUserAllowedToSave}
            readOnly={isUserAllowedToChangeProducerCodes === false}
            selected={selected}
            isNew={isNew}
            maskSensitiveData={maskSensitiveData}
            code={1}
          />

          <ProducerCodeAndName
            layout={{
              labelCol: { xxl: 8, xl: 8, lg: 8, md: 10, sm: 10, xs: 10 },
              wrapperCol: { xxl: 16, xl: 16, lg: 16, md: 14, sm: 14, xs: 14 },
            }}
            control={control}
            disabled={!isUserAllowedToSave}
            readOnly={isUserAllowedToChangeProducerCodes === false}
            selected={selected}
            isNew={isNew}
            maskSensitiveData={maskSensitiveData}
            code={2}
          />

          <CustomInput
            layout={{
              labelCol: { xxl: 8, xl: 8, lg: 8, md: 10, sm: 10, xs: 10 },
              wrapperCol: { xxl: 16, xl: 16, lg: 16, md: 14, sm: 14, xs: 14 },
            }}
            formLabel="Policy"
            control={control}
            name="PolicyNumber"
            maxLength={6}
            style={shortInputStyle}
            disabled={
              (selected &&
                (selected.IsDownloaded || selected.IsRegistration)) ||
              !isUserAllowedToSave
            }
            required={selected && selected.ProductKey != 41}
          />
          <CustomInput
            layout={{
              labelCol: { xxl: 8, xl: 8, lg: 8, md: 10, sm: 10, xs: 10 },
              wrapperCol: { xxl: 16, xl: 16, lg: 16, md: 14, sm: 14, xs: 14 },
            }}
            formLabel="Parent Policy"
            control={control}
            name="ParentPolicyNumber"
            style={shortInputStyle}
            maxLength={6}
            disabled={
              selected && (selected.IsDownloaded || !isUserAllowedToSave)
            }
          />

          {selected?.IsPlatedPolicy && (
            <CustomInput
              layout={{
                labelCol: { xxl: 8, xl: 8, lg: 8, md: 10, sm: 10, xs: 10 },
                wrapperCol: { xxl: 16, xl: 16, lg: 16, md: 14, sm: 14, xs: 14 },
              }}
              //if APV16, show PermitNumber
              formLabel={selected?.ProductKey === 17 ? "Permit" : "Plate"}
              control={control}
              name="PlateNumber"
              maxLength={6}
              style={shortInputStyle}
              disabled={!isUserAllowedToSave}
            />
          )}
        </Col>

        <Col xs={24} sm={24} md={24} lg={12} xl={8} xxl={8}>
          <SearchSelectEx
            control={control}
            layout={specialLayout}
            formLabel="Transaction"
            style={mediumInputStyle}
            name="TransactionType"
            options={transactionTypes}
            required={
              !(
                isDownloaded ||
                !isUserAllowedToSave ||
                (selected && selected.ProductKey === 41)
              )
            }
            disabled={
              isDownloaded ||
              !isUserAllowedToSave ||
              (selected && selected.ProductKey === 41)
            }
          />

          <CustomDatePicker
            formItem={{
              layout: specialLayout,
              label: "Effective",
              required: true,
            }}
            control={control}
            style={mediumInputStyle}
            name="PolicyEffectiveDate"
            format={dateFormat}
            disabled={isDownloaded || !isUserAllowedToSave}
          />

          {selected && selected.ProductKey !== 41 && (
            <CustomInput
              layout={specialLayout}
              formLabel="Timestamp"
              control={control}
              required={!isDownloaded}
              style={mediumInputStyle}
              name="DCID"
              maxLength={14}
              disabled={
                (isDownloaded && !selected.IsFinancial) || !isUserAllowedToSave
              }
            />
          )}

          <CustomDatePicker
            formItem={{
              layout: specialLayout,
              label: "Transaction Date",
              required: selected && selected.ProductKey === 41,
            }}
            control={control}
            style={
              selected && selected.ProductKey === 41
                ? mediumInputStyle
                : dateTimeInputStyle
            }
            showTime={!(selected && selected.ProductKey === 41)}
            name="EntryDateTime"
            format={
              selected && selected.ProductKey === 41
                ? dateFormat
                : dateTimeFormat
            }
            disabledDate={
              (current) => current && current > dayjs().endOf("day") // Disable future dates
            }
            disabled={!(selected && selected.ProductKey === 41)}
            placeholder={
              selected && selected.ProductKey === 41 ? "Select date" : ""
            }
          />
          <CustomDatePicker
            formItem={{
              layout: specialLayout,
              label: "Expiry",
            }}
            control={control}
            style={mediumInputStyle}
            name="PolicyExpiryDate"
            format={dateFormat}
            disabled={isDownloaded || !isUserAllowedToSave}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={8} xxl={8}>
          <CustomInput
            layout={specialLayout}
            formLabel="Document"
            control={control}
            name="DocumentNumber"
            maxLength={8}
            style={shortInputStyle}
            disabled={isDownloaded || !isUserAllowedToSave}
          />

          <CustomInput
            layout={specialLayout}
            formLabel="Dealer"
            control={control}
            name="DealerNumber"
            maxLength={5}
            disabled={isDownloaded || !isUserAllowedToSave}
            style={shortInputStyle}
          />

          <CustomInput
            layout={specialLayout}
            formLabel="Number of Owners"
            control={control}
            name="NumberOfOwners"
            disabled={isDownloaded || !isUserAllowedToSave}
            style={shortInputStyle}
          />

          <CustomInput
            layout={specialLayout}
            formLabel="Previous Plate"
            control={control}
            name="PreviousPlateNumber"
            maxLength={6}
            style={shortInputStyle}
            disabled={true}
          />
          {isUserAllowedToViewCommission === true && (
            <CustomInputCurrency
              layout={specialLayout}
              formLabel="Commission Amount"
              control={control}
              name="CommTotalAmt"
              disabled={true}
              isPrecision={true}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <CustomInputTextArea
            control={control}
            layout={{ labelCol: { span: 4 }, wrapperCol: { span: 20 } }}
            formLabel="Agent Comments"
            name="AgentComments"
            id="AgentComments"
            disabled={!isUserAllowedToSave}
            maxLength={255}
            className={maskSensitiveData === true ? "blurry-text" : ""}
          />
        </Col>
      </Row>
    </>
  );
};

export default React.memo(PolicyDocumentPanel);
